import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IEmailTemplate } from '../interfaces/email-template';
import { IEmailTemplateFilter } from '../interfaces/email-template-filter';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class EmailTemplateService extends EditService<IEmailTemplate, IEmailTemplateFilter> {
  url = '/api/emailtemplates';
  entityTitle = 'Template';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  getAll() {
    return this.handleRequest(
      this.http.get<IEmailTemplate[]>(this.url + '/getAll'),
      this.handlersFactory.getForReadAll(),
    );
  }

  checkCodeUrl() {
    return this.url + '/checkcode';
  }
}
